import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
   show(event) {
      this.element.showModal();
   }

   close(event) {
      this.element.close();
   }
}
